export default __webpack_public_path__ + "static/media/header3.50939b9d.jpg";